






















import { Component, Watch, Vue, Prop } from 'vue-property-decorator';
import { AttributeTreeData } from '@/models/reports/attribute-tree-data';
import { Field } from '@/models/reports/report-field';
import { setTimeout } from 'timers';
import { FieldSelectorSelection } from '@/models/field-selector/field-selector-selection';
import { ReportApi } from '@/api/report-api';
import { AttributeTreeEntry } from '@/models/reports/attribute-tree-entry';
import 'jstree';
import 'jstree/dist/themes/default/style.min.css';
import { sep } from 'path';

// tslint:disable-next-line
const $ = require('jquery');
(window as any).$ = $;
(window as any).jQuery = $;

const reportApi = new ReportApi();

@Component({})
export default class FieldSelector extends Vue {
    @Prop({ required: true }) private visible: boolean;
    private showing: boolean = this.visible;
    @Prop({}) private selectorOptions: FieldSelectorSelection;
    private loading: boolean = false;
    private forceSingleSelect: boolean;
    private searchText: string = '';
    private treeData: Array<AttributeTreeEntry> = [];
    private selections: Array<Field> = [];
    private timeout: NodeJS.Timer | undefined;
    private dialogTriggerElement: any = null;

    private options: any = {
        showSystemFields: true,
        showSystemEntities: false,
        selectorType: 'View',
        includeFieldVariations: false,
        forceSingleSelect: false,
        openInDialog: true,
        forceEntityTypeRestrictions: false, // forces the selector to restrict by entity types even if no entity types are selected (will return no results in that case)
        restrictToEntityTypes: '', // A comma separated list of entity types (Umbrella, Fund, ShareLetter, ShareClass)
        restrictToAccessPointTypes: '',
    };

    private get emptySelection(): boolean {
        return this.selections.length === 0;
    }

    private get singleSelection(): boolean {
        return this.selections.length === 1;
    }

    private get currentField(): Field | null {
        return this.selections.length === 1 ? this.selections[0] : null;
    }

    private get multiSelection(): boolean {
        return this.selections.length > 0;
    }

    private toggleShow(): void {
        this.showing = !this.showing;
    }

    private onCancel() {
        this.$emit('on-cancel');
    }
    @Watch('searchText')
    private searchTestUpdated(searchText: string): void {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
            if (searchText === '' || searchText.length >= 2) {
                $('.selector-tree').jstree(true).search(searchText);
            }
        }, 500);
    }

    private setFieldIsDisabled(field: any, disabled: boolean): void {
        if (!field.data.Selectable) {
            field.state.disabled = disabled;

            field.children.forEach((child: any) => {
                this.setFieldIsDisabled(child, disabled);
            });
        }
    }

    private addSelection(selection: any): void {
        const self = this;

        if (!selection) {
            return;
        }

        if (selection.data.selectable && selection.data.nodeId) {
            // can only select one node so remove other selections
            if (this.forceSingleSelect) {
                this.selections = [];
            }

            let exists = false;
            for (const selector of this.selections) {
                if (selector.nodeId === selection.data.nodeId) {
                    exists = true;
                    break;
                }
            }

            if (!exists) {
                this.selections.push(new Field(selection.data));
            }
        }

        // if this is a parent node then also select Children if we can
        if (selection.children && this.options.selectorType !== 'Entity') {
            selection.children.forEach((id: any) => {
                const childNode = $('.selector-tree').jstree(true).get_node(id);
                this.addSelection(childNode);
            });
        }
    }

    private removeSelection(selection: any): void {
        const self = this;

        if (!selection) {
            return;
        }

        if (selection.data.selectable && selection.data.nodeId) {
            this.selections = this.selections.filter((item) => {
                return item.nodeId !== selection.id;
            });
        }

        // if this is a parent node then also deselect Children if we can
        if (selection.children && this.options.selectorType !== 'Entity') {
            selection.children.forEach((id: any) => {
                const childNode = $('.selector-tree').jstree(true).get_node(id);
                this.removeSelection(childNode);
            });
        }
    }

    private buildSearchTextRegex(searchText: string): RegExp {
        let regex = searchText || '';

        if (regex.length > 2) {
            regex = '.*' + searchText + '.*';
        }

        return new RegExp('^' + regex + '$', 'i');
    }

    private initJsTree(readyCallback: () => void | null): void {
        const self = this;
        setTimeout(() => {
            $(this.$refs.tree)
                .jstree('destroy')
                .jstree({
                    core: {
                        data: this.treeData,
                        multiple: !this.forceSingleSelect,
                    },
                    search: {
                        fuzzy: false,
                        search_leaves_only: true,
                        search_callback: (searchTerm: string, node: any) => {
                            const regex = this.buildSearchTextRegex(searchTerm);
                            return node.text.search(regex) >= 0 || node.id.search(regex) >= 0;
                        },
                        show_only_matches: true,
                    },
                    checkbox: {
                        tie_selection: false,
                        three_state: this.options.selectorType !== 'Entity' && !this.forceSingleSelect,
                        keep_selected_style: false,
                    },
                    types: {},
                    plugins: ['ui', 'search', 'checkbox', 'types'],
                })
                .on('ready.jstree', readyCallback)
                .on('check_node.jstree', (node: any, selected: any, event: any) => {
                    if (this.forceSingleSelect) {
                        $('.selector-tree').jstree(true).uncheck_node(this.selections.map((item: any) => {
                            return item.nodeId;
                        }), null);
                    }

                    this.addSelection(selected.node);

                    $('.selector-tree').jstree(true).open_node(selected.node.parents);

                    if (this.options.selectorType !== 'Entity') {
                        $('.selector-tree').jstree(true).open_all(selected.node);
                    }
                }).on('uncheck_node.jstree', (node: any, selected: any, event: any) => {
                    this.removeSelection(selected.node);
                });
        }, 0);
    }

    private async open(): Promise<void> {
        this.showing = true;
        await this.load();
    }

    private async load(): Promise<void> {
        if (this.loading) {
            return;
        }

        this.loading = true;

        const queryData = {
            ShowSystemFields: this.options.showSystemFields,
            ShowSystemEntities: this.options.showSystemEntities,
            SelectorType: this.options.selectorType,
            IncludeFieldVariations: this.options.includeFieldVariations,
            ForceEntityTypeRestrictions: this.options.forceEntityTypeRestrictions,
            RestrictToEntityTypes: this.options.restrictToEntityTypes,
            RestrictToAccessPointTypes: this.options.restrictToAccessPointTypes,
        };

        this.treeData = await reportApi.getSelectorsAsync();
        // this.initJsTree(() => { $('.selector-tree').jstree('redraw'); });
        this.initJsTree(() => {
            const jstree = $('.selector-tree').jstree(true);

            if (this.selectorOptions.Selections) {
                // pre-select items
                $.each(this.selectorOptions.Selections, (index: any, item: any) => {
                    const nodeId = item.nodeId;
                    if (nodeId) {
                        const node = jstree.get_node(nodeId);
                        if (node) {
                            node.data.customDisplayName = item.customDisplayName;
                            node.data.aggregateType = item.aggregateType;

                            jstree.check_node(node, null);
                        }
                    }
                });
            }

            // Client side filtering of Entity Types only affects the field selector.
            // The entity selector filtering is handled on the server.
            const isFieldSelector = this.options.selectorType === 'Field' || this.options.selectorType === 'View';
            const restrictByEntity = this.selectorOptions.RestrictToEntityTypes && this.selectorOptions.RestrictToEntityTypes.length > 0;
            const restrictByField = this.selectorOptions.RestrictToFields && this.selectorOptions.RestrictToFields.length > 0; // if it's supplied then restrict to just these attributes, even if empty

            if (isFieldSelector && (restrictByEntity || restrictByField)) {
                jstree.hide_all(true);

                if (restrictByField) {
                    $.each(this.selectorOptions.RestrictToFields, (index: any, fieldId: any) => {
                        this.showNodeAndParentsById(jstree, fieldId);
                    });
                } else if (restrictByEntity) {
                    $.each(this.selectorOptions.RestrictToEntityTypes, (index: any, entityTypeId: any) => {
                        if (typeof entityTypeId !== 'number') {
                            entityTypeId = parseInt(entityTypeId, 10);
                        }

                        if (!isNaN(entityTypeId)) {
                            // show all nodes for the entity type
                            const nodeId = $('#field-selector li[entitytypeid="' + entityTypeId + '"][aria-level="1"').attr('id');
                            const node = jstree.get_node(nodeId);

                            if (node && node.a_attr.id.indexOf('_anchor') >= 0) {
                                node.state.disabled = true;
                            }

                            this.showNodeAndChildrenById(jstree, nodeId);
                            if (this.selectorOptions.RestrictToEntityTypes.length === 1) {
                                node.state.opened = true;
                            }
                        }
                    });
                }
                // redraw the full tree. Redrawing the full tree seems MUCH faster than trying to let jstree work out what has changed
                jstree.redraw(true);
            } else {
                jstree.show_all(false);
            }
        });

        this.loading = false;
        this.forceSingleSelect = this.selectorOptions.SingleSelect;
    }

    private save(): void {
        this.$emit('on-selection', this.selections.slice(0), this.dialogTriggerElement);
        this.showing = false;
    }

    private showNodeAndParents(jstree: any, node: any): void {
        jstree.show_node(node, true);

        if (node.parents) {
            for (const parent of node.parents) {
                this.showNodeAndParentsById(jstree, parent);
            }
        }
    }

    private showNodeAndParentsById(jstree: any, nodeId: any): void {
        const node = jstree.get_node(nodeId);

        this.showNodeAndParents(jstree, node);
    }

    private showNodeAndChildren(jstree: any, node: any): void {
        jstree.show_node(node, true);

        if (node.children) {
            for (const child of node.children) {
                this.showNodeAndChildrenById(jstree, child);
            }
        }
    }

    private showNodeAndChildrenById(jstree: any, nodeId: any): void {
        const node = jstree.get_node(nodeId);
        this.showNodeAndChildren(jstree, node);
    }

    private async mounted(): Promise<void> {
        $.jstree.defaults.plugins = ['ui'];
        await this.load();
    }
}
